// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Actions from "../../../../actions/contactSources";
import ModalForm from "./Form";

class ContactSourceModal extends Component {
  onSave = () => {
    if (this.props.contactSource.id) {
      this.props
        .dispatch(Actions.onUpdate(this.props.contactSource.id))
        .then(() => {
          this.props.dispatch(Actions.fetchContactSources());
        });
    } else {
      this.props.dispatch(Actions.onCreate()).then(() => {
        this.props.dispatch(Actions.fetchContactSources());
      });
    }
  };

  onCancel = () => {
    this.props.dispatch(Actions.onToggleVisible());
  };

  onChangeName = e => {
    this.props.dispatch(Actions.onChangeName(e.target.value));
  };

  

  render() {
    const { isLoading, contactSource, isModalVisible } = this.props;
    return (
      <ModalForm
        isLoading={isLoading}
        visible={isModalVisible}
        contactSource={contactSource}
        onSave={this.onSave}
        onCancel={this.onCancel}
        onChangeName={this.onChangeName}
        destroyOnClose
      />
    );
  }
}

ContactSourceModal.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  contactSource: PropTypes.object,
  isLoading: PropTypes.bool,
  errors: PropTypes.bool
};

const mapStateToProps = state => ({
  isLoading: state.contactSources.isLoading,
  isModalVisible: state.contactSources.isModalVisible,
  errors: state.contactSources.errors,
  contactSource: state.contactSources.contactSource
});

export default connect(mapStateToProps)(withRouter(ContactSourceModal));
